import { colors, variables } from "../../../common/styles";

const { blackTransparent, green, red, darkGrey } = colors;
const { sideBarWidth } = variables;

const THUMB_SIZE = 84;
const TOOLBAR_HEIGHT = 50;

const columnLabel = {
    fontSize: "0.80em",
    display: "inline-block",
    overflow: "hidden",
    textTransform: "capitalize",
    textOverflow: "ellipsis",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    textTransform: "capitalize"
};

export default (theme) => ({
    auditImage: {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "block",
        position: "relative",
        height: `calc(50% - ${parseInt(theme.spacing()) * 4}px)`,
        minHeight: `calc(50% - ${parseInt(theme.spacing()) * 4}px)`,
        width: "100%",
        transition: theme.transitions.create("opacity"),
        "&:hover": {
            opacity: 0.7
        },
        "&:active": {
            opacity: 0.5
        }
    },
    auditImageDetailContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(1)}`
    },
    auditImageDetail: {
        marginTop: theme.spacing(2)
    },
    auditImageDialog: {
        height: "80vh"
    },
    avatarIdentifier: {
        position: "absolute",
        top: "3px",
        left: "3px",
        zIndex: "1"
    },
    avatarIdentifierSmall: {
        background: green,
        color: "#fff",
        width: "25px",
        height: "25px",
        fontSize: "15px"
    },
    auditImageIdentifier: {
        backgroundColor: blackTransparent,
        color: theme.palette.common.white,
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        position: "absolute",
        width: "100%",
        bottom: 0
    },
    auditImageThumb: {
        background: "transparent",
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        opacity: 1.0,
        transition: theme.transitions.create("opacity"),
        "&:hover": {
            opacity: 0.7
        },
        "&:active": {
            opacity: 0.5
        }
    },
    auditImageThumbContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start"
    },
    auditImageThumbs: {
        display: "flex",
        flexDirection: "row",
        width: "auto",
        overflow: "auto",
        "& > div": {
            position: "relative",
            cursor: "pointer"
        }
    },
    auditImageAdd: {
        borderRadius: "10px",
        color: "#3b3d3d",
        display: "block",
        fontWeight: "100",
        fontSize: "3em",
        fontFamily: "Roboto",
        height: THUMB_SIZE,
        width: THUMB_SIZE
    },
    auditImageClose: {
        color: "#fff",
        position: "absolute",
        right: 0,
        zIndex: 1
    },
    auditImageSave: {
        cursor: "pointer",
        position: "absolute",
        right: "2%",
        top: "1%",
        zIndex: 1
    },
    booleanIcon: {
        color: ({ value }) => (value ? green : red),
        display: "block",
        width: "100%",
        textAlign: "center"
    },
    container: {
        display: "block",
        height: "100%"
    },
    contentContainer: {
        height: "100%",
        width: `calc(100% - ${sideBarWidth}px)`,
        overflow: "auto"
    },
    columnLabel: {
        color: darkGrey,
        width: theme.spacing(24),
        marginRight: theme.spacing(1),
        ...columnLabel
    },
    columnLabelLink: {
        ...columnLabel,
        color: "primary",
        cursor: "pointer",
        marginRight: theme.spacing(1),
        textDecoration: "underline",
        width: "auto"
    },
    columnIcon: {
        color: "#b4b4b6",
        verticalAlign: "middle",
        marginRight: "5px"
    },
    columnText: {
        textTransform: "capitalize",
        display: "inline-block",
        width: "auto",
        fontSize: "0.85em",
        textOverflow: "ellipsis",
        overflow: "hidden",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        width: `${parseInt(theme.spacing(1.6))}em`
    },
    commonSpacing: {
        padding: `${theme.spacing(0.5)} ${theme.spacing(3)} !important`
    },
    displayInlineBlock: {
        display: "inline-block"
    },
    editIcon: {
        cursor: "pointer",
        marginRight: theme.spacing(1),
        verticalAlign: "middle"
    },
    error: {
        color: "#f44336"
    },
    flexGrow: {
        flexGrow: 1
    },
    fullHeight: {
        height: "100%"
    },
    fullWidth: {
        width: "100%"
    },
    failure: {
        color: red
    },
    imageController: {
        cursor: "pointer",
        height: "100%",
        overflow: "hidden",
        width: "100%"
    },
    lightGrey: {
        color: "#e0e0e0"
    },
    marginRight: {
        marginRight: theme.spacing(2)
    },
    sharedLayoutColor: {
        backgroundColor: colors.blue
    },
    leftLayoutComponent: {
        "& .MuiAccordion-root": {
            background: "transparent"
        }
    },
    navigationIcon: {
        position: "absolute",
        top: "0",
        bottom: "0",
        margin: "auto",
        height: "50px"
    },
    navigationLeft: {
        left: "5%"
    },
    navigationRight: {
        right: "0%"
    },
    overflowY: {
        overflowY: "auto"
    },
    padding: {
        padding: theme.spacing(3)
    },
    rotateLeftIcon: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "1px 2px 10px 0px #165550",
        bottom: 0,
        left: "2%",
        margin: "auto",
        position: "absolute",
        top: 0,
        zIndex: 2
    },
    rotateRightIcon: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "1px 2px 10px 0px #165550",
        bottom: 0,
        margin: "auto",
        position: "absolute",
        right: "2%",
        top: 0,
        zIndex: 2
    },
    spacer: {
        height: theme.spacing(3)
    },
    success: {
        color: green
    },
    toolbar: {
        backgroundColor: theme.palette.grey["50"],
        borderBottom: `1px solid ${theme.palette.grey["200"]}`,
        borderTop: `1px solid ${theme.palette.grey["200"]}`,
        height: TOOLBAR_HEIGHT,
        overflow: "auto"
    },
    toolbarActions: {
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    toolbarBack: {
        paddingRight: theme.spacing(1.5),
        width: `calc(${sideBarWidth}px)`
    },
    toolbarHeader: {
        marginLeft: "1rem"
    },
    toolbarContent: {
        width: `calc(100% - ${sideBarWidth}px)`
    },
    toolbarSubHeading: {
        fontSize: "1em",
        width: "250px",
        whiteSpace: "pre",
        textOverflow: "ellipsis",
        overflow: "hidden"
    },
    toolbarNav: {
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5)
    },
    toolbarProgress: {
        height: theme.spacing(1),
        borderRadius: theme.spacing(5),
        width: "100%"
    },
    toolbarProgressText: {
        textTransform: "uppercase",
        color: colors.lightGrey,
        "&>span": {
            color: colors.black
        }
    }
});
/** TODO
 * Convert the styles to use the makeStyles hook
 */
